// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__Tur3c","label":"styles_label__8qTlB","caption":"styles_caption__Gd_2e","description":"styles_description__2RAIv","content":"styles_content__l6fBm"};